import * as React from "react"
import type { SVGProps } from "react"
const SvgRecPerson = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M12 12.43q-1.65 0-2.82-1.18Q8 10.08 8 8.43c0-1.65.4-2.04 1.18-2.83Q10.35 4.43 12 4.43c1.65 0 2.04.39 2.83 1.17Q16 6.78 16 8.43c0 1.65-.4 2.04-1.17 2.82A4 4 0 0 1 12 12.43m0-2q.83 0 1.41-.59.6-.6.59-1.41 0-.82-.59-1.41A2 2 0 0 0 12 6.43q-.83 0-1.41.59A2 2 0 0 0 10 8.43q0 .82.59 1.41.58.6 1.41.59"
    />
    <path d="M4 18.43v-.8q0-.86.44-1.56t1.16-1.1a15 15 0 0 1 3.15-1.15 14 14 0 0 1 3.25-.39 14 14 0 0 1 3.66.5l-.37.3-1.36 1.36a12 12 0 0 0-4.7.18q-1.38.34-2.73 1a1 1 0 0 0-.5.86v.8h7v2H6q-.82 0-1.41-.59A2 2 0 0 1 4 18.43m11.95 3a1 1 0 0 1-.67-.28 1 1 0 0 1-.28-.67v-2.85q0-.14.06-.27l.15-.22 1.5-1.5a.7.7 0 0 1 .5-.21q.3 0 .53.24.22.23.17.6l-.16.89h2.47q.2 0 .34.14.13.14.13.33v.6l-.05.26L19.58 21a1 1 0 0 1-.27.32 1 1 0 0 1-.4.1z" />
  </svg>
)
export default SvgRecPerson
